import { useQuery } from '@tanstack/react-query';

import { authTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

// `permissions` is absent (or null) on legacy backends that predate ACL —
// usePermissions falls back to "everything visible" when the list is missing.
export const getAccount = (): Promise<{
  account: authTypes.Account;
  permissions?: string[] | null;
}> => {
  return axios.get('/accounts/me');
};

type QueryFnType = typeof getAccount;

type UseGetAccountOptions = {
  config?: QueryConfig<QueryFnType>;
};

export function useAccount({ config }: UseGetAccountOptions = {}) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['account-me'],
    queryFn: getAccount,
    ...config,
  });
}
